'use client'
import { useEffect } from 'react'
import { usePathname, useSearchParams, useRouter } from 'next/navigation'
import { useDispatch, useSelector } from 'react-redux'
import { Box } from '@quintoandar-tokko/jopijs'
import {
  VisitInformationFooter,
  VisitInformationHeader,
  VisitInformationPropertyCard,
  VisitInformationTitle,
  VisitInformationVisitDetails,
} from './components'
import { setCalendarData } from '@/store/slices/components/calendar/CalendarSlice'
import getVisitStatus from '../utils/getVisitStatus'
import style from './visitInformation.module.scss'

export default function VisitInformation () {
  const pathname = usePathname()
  const dispatch = useDispatch()
  const { visit } = useSelector(state => state.CalendarSlice)
  const searchParams = useSearchParams()
  const router = useRouter()
  const isCalendarPage = pathname.includes('/calendar/')
  const isVisitPage = pathname.includes('/visit/')
  const visitStatus = getVisitStatus(visit)

  useEffect(() => {
    const cancelVisitParam = searchParams.get('cancel_visit')
    const shouldShowCancelModal = cancelVisitParam === '1' && visitStatus.isConfirmed

    if (shouldShowCancelModal) {
      dispatch(setCalendarData({ key: 'visit', subkey: 'cancelVisitModalOpen', value: true }))
    }

    if (cancelVisitParam) {
      const current = new URLSearchParams(Array.from(searchParams.entries()))
      current.delete('cancel_visit')
      const newSearch = current.toString()
      const newPath = `${window.location.pathname}${newSearch ? '?' + newSearch : ''}`
      router.replace(newPath)
    }
  }, [])

  return (
		<Box
      className={style.visitInformation}
      data-shrink={isCalendarPage}
      data-visit-view={isVisitPage}
    >
      <VisitInformationHeader />
      <VisitInformationTitle />

      <Box className={style.visitInformationMainContent}>
        <VisitInformationPropertyCard />
        <VisitInformationVisitDetails />
      </Box>

      <VisitInformationFooter />
    </Box>
  )
}
